import Create from "./Create";
import Edit from "./Edit";
import { LanguageMessageIcon } from "../icons";
import List from "./List";

export default {
  options: {
    group: "admin",
    accessible: ({ user }) =>
      user.role === "admin" && user.permissions.indexOf("group/list"),
  },
  icon: LanguageMessageIcon,
  list: List,
  edit: Edit,
  create: Create,
};
